import cssUtil from 'gw-portals-util-js/CssUtil';
import template from 'text!./thumbsubtext.html';
import styles from './thumb-subtext-hashed.scss';

/**
 * @ngdoc component
 * @name gw-thumb-subtext
 *
 * @description Component of thumblist to display the subtext of a thumb
 *
 */
export default {
    template: cssUtil.hashTemplate(template, styles),
    transclude: true
};
